export default __webpack_public_path__ + "static/media/bookmark.5050c5ff.svg";